var _path, _path2, _path3, _path4, _g, _g2, _g3, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 121,
    viewBox: "0 0 116 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9193 97.3904C98.0496 97.0757 98.1167 96.7385 98.1167 96.3979V78.2382H79.4949V96.3979C79.4949 96.7391 79.5622 97.0769 79.6929 97.3921C79.8237 97.7072 80.0154 97.9934 80.257 98.2344C80.4986 98.4753 80.7854 98.6662 81.1009 98.7961C81.4163 98.926 81.7543 98.9924 82.0955 98.9915H95.5231C95.8637 98.9915 96.201 98.9244 96.5157 98.7941C96.8304 98.6637 97.1163 98.4727 97.3572 98.2318C97.598 97.991 97.789 97.7051 97.9193 97.3904Z",
    fill: "url(#paint0_linear_5_682)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7283 34.1637C79.5747 34.5014 79.4951 34.8679 79.4949 35.2389V63.3078H98.1167V23.4721C98.1168 22.9735 97.9732 22.4854 97.7031 22.0663C97.433 21.6473 97.0478 21.3149 96.5937 21.1091C96.1396 20.9033 95.6358 20.8327 95.1426 20.9059C94.6494 20.979 94.1877 21.1928 93.8129 21.5216L80.3853 33.2813C80.1059 33.5252 79.8819 33.8261 79.7283 34.1637Z",
    fill: "url(#paint1_linear_5_682)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1071 98.2325C17.6207 97.746 17.3474 97.0864 17.3474 96.3985V78.0424H35.9621V96.3985C35.9621 97.0864 35.6889 97.746 35.2025 98.2325C34.7161 98.7188 34.0564 98.9921 33.3686 98.9921H19.941C19.2531 98.9921 18.5935 98.7188 18.1071 98.2325Z",
    fill: "url(#paint2_linear_5_682)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7327 34.165C35.885 34.5026 35.9632 34.869 35.9621 35.2395V63.5048H17.3474V23.4727C17.3473 22.9741 17.4909 22.486 17.761 22.067C18.0311 21.6479 18.4163 21.3155 18.8704 21.1097C19.3245 20.9039 19.8284 20.8333 20.3216 20.9065C20.8148 20.9796 21.2763 21.1934 21.6512 21.5222L35.0787 33.2819C35.3573 33.5262 35.5803 33.8273 35.7327 34.165Z",
    fill: "url(#paint3_linear_5_682)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8333 44.1367L54.4694 46.0237C53.3524 46.3099 52.1824 46.3198 51.0607 46.0526C49.939 45.7854 48.8992 45.2491 48.0311 44.4901L21.6424 21.5219C21.2665 21.1914 20.8033 20.9763 20.3082 20.9026C19.8131 20.8289 19.3071 20.8996 18.8513 21.1063C18.3954 21.313 18.0089 21.6469 17.738 22.0678C17.4672 22.4888 17.3236 22.979 17.3245 23.4795V42.4618C17.3255 42.8344 17.4061 43.2023 17.5608 43.5412C17.7156 43.88 17.9411 44.1819 18.222 44.4265L38.1584 61.7057C38.6328 62.1178 39.2401 62.3448 39.8686 62.3448C40.497 62.3448 41.1043 62.1178 41.5788 61.7057L48.4411 55.7269L61.8333 44.1367Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5_682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.8152 38.0663C78.6418 43.8267 84.4644 47.9676 91.1616 49.6917L97.2392 44.4267C97.7326 43.9964 98.0455 43.3957 98.1155 42.7447V23.4727C98.1202 23.0307 98.01 22.5951 97.7956 22.2086C97.5813 21.8221 97.2702 21.4979 96.8929 21.2677C96.845 21.2368 96.7955 21.2085 96.7445 21.1829L96.5396 21.084C96.4066 21.0287 96.2697 20.9838 96.1298 20.9497L95.9177 20.9073H95.7552H95.6915C95.4545 20.8902 95.2162 20.9093 94.9848 20.9638H94.8718H94.7657L94.6598 20.9992L94.4972 21.0698C94.4434 21.0915 94.3914 21.1175 94.3418 21.1476L94.1368 21.2677L93.9955 21.3667C93.946 21.4091 93.8895 21.4444 93.84 21.4939L93.2322 22.0168L74.8152 38.0663Z",
    fill: "url(#paint4_linear_5_682)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5_682)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1164 23.494V42.4693C98.1163 42.5792 98.1093 42.6887 98.0955 42.7973V42.7446C98.0255 43.3956 97.7126 43.9963 97.2191 44.4266L79.4735 59.8188V59.9321L79.4734 59.9322L75.6024 63.3076H45.8797L79.4734 34.0452L93.7843 21.5293C94.1613 21.197 94.6262 20.9807 95.1232 20.9065C95.6202 20.8322 96.1282 20.9031 96.5858 21.1106C97.0435 21.3182 97.4314 21.6535 97.703 22.0764C97.9746 22.4992 98.118 22.9915 98.1164 23.494ZM40.3779 78.238V88.2997C40.3771 88.8002 40.5207 89.2904 40.7915 89.7113C41.0623 90.1323 41.449 90.4661 41.9049 90.6728C42.3608 90.8795 42.8665 90.9502 43.3616 90.8765C43.8567 90.8028 44.3201 90.5878 44.696 90.2572L58.4799 78.238H40.3779Z",
    fill: "#FEFEFE"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9172 71.5395C29.9172 71.7222 29.9054 71.8872 29.8818 72.0345H26.1606C26.19 72.4234 26.3344 72.7357 26.5937 72.9714C26.853 73.2071 27.1712 73.325 27.5483 73.325C28.0904 73.325 28.4735 73.0981 28.6974 72.6444H29.7846C29.6373 73.0922 29.3692 73.4605 28.9802 73.7493C28.5972 74.0321 28.1199 74.1735 27.5483 74.1735C27.0828 74.1735 26.6644 74.0704 26.2932 73.8642C25.9278 73.652 25.6391 73.3574 25.4269 72.9803C25.2207 72.5972 25.1176 72.1553 25.1176 71.6544C25.1176 71.1535 25.2177 70.7145 25.4181 70.3374C25.6243 69.9544 25.9101 69.6597 26.2755 69.4535C26.6467 69.2472 27.071 69.1441 27.5483 69.1441C28.0079 69.1441 28.4175 69.2443 28.7769 69.4446C29.1364 69.645 29.4163 69.9278 29.6167 70.2932C29.817 70.6526 29.9172 71.0681 29.9172 71.5395ZM28.8653 71.2213C28.8594 70.8501 28.7269 70.5525 28.4676 70.3286C28.2083 70.1046 27.8871 69.9927 27.5041 69.9927C27.1565 69.9927 26.8589 70.1046 26.6114 70.3286C26.3639 70.5466 26.2166 70.8442 26.1694 71.2213H28.8653ZM45.8203 67.9508V74.094H44.8127V69.8866L42.9388 74.094H42.2405L40.3578 69.8866V74.094H39.3501V67.9508H40.4373L42.5941 72.7681L44.742 67.9508H45.8203ZM59.2896 72.8388H56.7175L56.2755 74.094H55.2237L57.4246 67.942H58.5913L60.7923 74.094H59.7316L59.2896 72.8388ZM59.0068 72.0168L58.008 69.1618L57.0003 72.0168H59.0068ZM74.6366 69.7187C74.4775 69.4122 74.2565 69.1824 73.9737 69.0292C73.6908 68.8701 73.3638 68.7906 72.9925 68.7906C72.5859 68.7906 72.2235 68.8819 71.9053 69.0646C71.5871 69.2472 71.3367 69.5065 71.154 69.8424C70.9772 70.1783 70.8888 70.5672 70.8888 71.0092C70.8888 71.4511 70.9772 71.843 71.154 72.1848C71.3367 72.5206 71.5871 72.7799 71.9053 72.9626C72.2235 73.1453 72.5859 73.2366 72.9925 73.2366C73.5405 73.2366 73.9854 73.0834 74.3272 72.777C74.669 72.4706 74.8782 72.0551 74.9548 71.5307H72.6478V70.7263H76.0332V71.513C75.9683 71.9903 75.7975 72.4293 75.5205 72.83C75.2494 73.2307 74.8929 73.5519 74.451 73.7935C74.0149 74.0292 73.5288 74.147 72.9925 74.147C72.415 74.147 71.8876 74.0144 71.4103 73.7493C70.933 73.4782 70.5529 73.104 70.2701 72.6267C69.9931 72.1494 69.8547 71.6102 69.8547 71.0092C69.8547 70.4081 69.9931 69.8689 70.2701 69.3916C70.5529 68.9143 70.933 68.5431 71.4103 68.2779C71.8935 68.0068 72.4209 67.8713 72.9925 67.8713C73.6466 67.8713 74.227 68.0333 74.7338 68.3574C75.2465 68.6756 75.6177 69.1294 75.8475 69.7187H74.6366ZM86.4406 73.2189H89.2956V74.094H85.2473V73.3073L88.0935 68.8259H85.2473V67.9508H89.2956V68.7375L86.4406 73.2189Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0921 119.533H115.184V60.2668M1.00057 60.2668V1.00037H58.0921",
    stroke: "white",
    strokeWidth: 1.08746
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8979 37.988C36.1295 43.6489 30.4038 47.7192 23.819 49.4183L17.8503 44.2417C17.3605 43.8184 17.05 43.2247 16.9817 42.581V23.6672C16.9794 23.2313 17.0894 22.8022 17.3012 22.4213C17.513 22.0403 17.8193 21.7204 18.1908 21.4923L18.3297 21.4159L18.5382 21.3186C18.6661 21.2632 18.7987 21.219 18.9343 21.1866H19.1427H19.3025H19.3651C19.5982 21.166 19.8331 21.1848 20.0599 21.2421H20.1711L20.2753 21.2769H20.3865L20.5394 21.3394L20.6992 21.4159C20.7694 21.4525 20.8367 21.4943 20.9007 21.5409L21.0396 21.6382L21.1925 21.7563L21.7901 22.2775L39.8979 37.988Z",
    fill: "url(#paint5_linear_5_682)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5718 37.989C79.3389 43.648 85.0617 47.7181 91.6436 49.4193L97.6124 44.2427C98.0995 43.8172 98.4094 43.2247 98.481 42.582V23.6682C98.491 23.2303 98.3875 22.7972 98.1805 22.4112C97.9735 22.0252 97.67 21.6994 97.2997 21.4655L97.1538 21.3891L96.9523 21.2918C96.8239 21.2374 96.6915 21.1933 96.5562 21.1598H96.3408H96.1879H96.1185C95.8854 21.1392 95.6505 21.158 95.4236 21.2154H95.3194L95.2082 21.2501H95.104L94.9442 21.3126L94.7913 21.3891C94.7202 21.4241 94.6527 21.466 94.5898 21.5141L94.4439 21.6114L94.298 21.7295L93.7004 22.2507L75.5718 37.989Z",
    fill: "url(#paint6_linear_5_682)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_682",
    x: 14.5451,
    y: 20.8743,
    width: 50.0676,
    height: 47.0293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.7794
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3897
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_682",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5_682",
    x: 73.2436,
    y: 20.9012,
    width: 26.4438,
    height: 37.8274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.46521
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.785811
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_682",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5_682",
    x: 37.5985,
    y: 20.8778,
    width: 63.2973,
    height: 75.5859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.7794
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3897
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_682",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_682",
    x1: 88.8058,
    y1: 20.8778,
    x2: 88.8058,
    y2: 98.9915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_682",
    x1: 88.8058,
    y1: 20.8778,
    x2: 88.8058,
    y2: 98.9915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_682",
    x1: 26.5477,
    y1: 34.7085,
    x2: 26.5477,
    y2: 113.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203438,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_682",
    x1: 26.5477,
    y1: 34.7085,
    x2: 26.5477,
    y2: 113.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203438,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_682",
    x1: 123291,
    y1: 9813.13,
    x2: 123079,
    y2: 9813.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_682",
    x1: 17.1763,
    y1: 35.2503,
    x2: 23.4994,
    y2: 35.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2ADB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A2ADB4",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A2ADB4",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A2ADB4",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2ADB4",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2ADB4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_682",
    x1: 104.172,
    y1: 27.3198,
    x2: 89.5799,
    y2: 27.3198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.482245,
    stopColor: "#A2ADB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965253,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent2);
export default __webpack_public_path__ + "static/media/Component 2.06002c638046ec4a7f6c2e8dd04e610f.svg";
export { ForwardRef as ReactComponent };